<template>
  <div class="dialog-confirm text-center">
    <div class="close cursor-pointer" @click="$emit('close')"><i class="owl-status-error"></i></div>
    <figure>
      <img src="@/assets/images/promotion/success-mail.png" alt="">
    </figure>
    <strong class="text-2xl text-green-dark font-bold mb-16 block">{{ title }}</strong>
    <p class="text-grey-darker font-medium mb-32">{{ subtitle }}</p>

    <button class="btn btn-solid btn-green-dark px-32" @click="$emit('close')">{{ $t('confirm') }}</button>
  </div>
</template>

<script>
export default {
  name: 'dialog-confirm',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    hasImage: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="sass" scoped>
.dialog-confirm
  @apply p-32 relative
  .close
    @apply absolute text-grey text-xl
    top: 12px
    right: 12px
  figure
    @apply mb-8
    height: 80px
    img
      height: 100%
</style>
